<template>
  <section v-if="new_products && new_products.length" class="mt-4">
    <div>
      <HeaderSection
        :textBtn="'مشاهده بیشتر'"
        :text="'جدیترین ها'"
        :route="'/products?sort=newest'"
      />
      <div id="newProductSwiper" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(product, index) in new_products"
            :key="index"
          >
            <Product :product="product"></Product>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Product from "@/parts/Front/components/product/Product";
import Swiper from "swiper/swiper-bundle.min";
import HeaderSection from "@/parts/Front/components/HeaderSection";

export default {
  components: {
    Product,
    HeaderSection,
  },
  computed: {
    new_products() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return [];
      } else {
        return this.$store.getters["front/getHomeData"].new_products;
      }
    },
  },
  methods: {
    initNewProduct(kill = false) {
      this.initSwiper("myNewProduct", kill, () => {
        new Swiper("#newProductSwiper.swiper-container", {
          spaceBetween: 50,
          loop: false,
          speed: 500,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".similar-products .swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            250: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            // 1200: {
            // slidesPerView: 3,
            // spaceBetween: 0,
            // }
          },
        });
      });
    },
  },
  watch: {
    new_products(newValue) {
      if (newValue) {
        this.initNewProduct(true);
      }
    },
  },
  mounted() {
    this.initNewProduct();
  },
};
</script>

<style></style>
